<template lang="pug">
q-header.header.flex.items-center
    q-toolbar.font-14.d-nonex
        .wrapper.row.justify-between.relative-position
            q-btn.absolute-top-left.q-mt-md(
                round
                color="secondary"
                padding="12px"
                @click="goBack"
                style="z-index: 99; left: -55px; top: -4px;")
                q-icon(
                    size="18px"
                    color="positive"
                    name="etabl:arrow_prev")
            .col-5
                img.cursor-pointer(
                    src="interface/franchise/logo_franchise.svg"
                    style="width: 194px; height: 66px;"
                    @click="goToPage('/franchise')")
            .col-7.link.justify-between.flex.items-center
                template(v-for="item in links")
                    router-link.link.font-18.text-positive(
                        :to="city ? `/${city.slug}/${item.route}` : `/${item.route}`"
                        :class="item.route == $route.name ? 'text-weight-bold' : ''"
                        :title="`${item.label}`"
                    )
                        | {{ item.label }}

</template>

<script>
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';

export default {
    name: 'HeaderFranchise',
    setup() {
        const router = useRouter();
        const store = useStore();

        // город пользователя
        const city = computed(() => store.getters['cityForm/CITY']);

        const links = computed(() => [
            {
                label: 'Форматы сотрудничества',
                route: 'franchise',
            }, {
                label: 'Новая аптека',
                route: 'franchise-new',
            }, {
                label: 'Ребрендинг аптеки',
                route: 'franchise-rebrand',
            }, 
        ]);

        const goToPage = (page) => {
            router.push(city.value ? `/${city.value.slug}/${page}` : page);
        };

        const goBack = () => router.go(-1);

        return {
            links,
            goBack,
            goToPage,
            city,
        };
    },
};

</script>

<style lang="scss" scoped>
.q-header {
    background: $secondary;
    height: 102px;
    font-family: "Montserrat";
}
</style>
